import * as stylex from '@stylexjs/stylex';
import { styles } from '../styles';
import { ReactComponent as LinkedIn } from './icons/linkedin.svg';
import { ReactComponent as Discord } from './icons/discord.svg';
import { ReactComponent as Gmail } from './icons/gmail.svg';
import { ReactComponent as Facebook } from './icons/facebook.svg';
import { ReactComponent as YouTube } from './icons/youtube.svg';
import { ReactComponent as GitHub } from './icons/github.svg';
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
export const Footer = () => {
  const currentYear = new Date().getFullYear();
  return /*#__PURE__*/_jsxs("div", {
    ...stylex.props(styles.credits),
    children: [/*#__PURE__*/_jsxs("h4", {
      children: ["Compiled for web by Kote Kutalia \xA9 ", currentYear]
    }), /*#__PURE__*/_jsx("a", {
      href: "https://www.linkedin.com/in/kote-kutalia",
      target: "_blank",
      rel: "noopener noreferrer",
      ...stylex.props(styles.socialLink),
      children: /*#__PURE__*/_jsx(LinkedIn, {
        ...stylex.props(styles.social)
      })
    }), /*#__PURE__*/_jsx("a", {
      href: "https://github.com/kutalia",
      target: "_blank",
      rel: "noopener noreferrer",
      ...stylex.props(styles.socialLink),
      children: /*#__PURE__*/_jsx(GitHub, {
        ...stylex.props(styles.social)
      })
    }), /*#__PURE__*/_jsx("a", {
      href: "https://discord.gg/mjAsMfMxSQ",
      target: "_blank",
      rel: "noopener noreferrer",
      ...stylex.props(styles.socialLink),
      children: /*#__PURE__*/_jsx(Discord, {
        ...stylex.props(styles.social)
      })
    }), /*#__PURE__*/_jsx("a", {
      href: "mailto:kotekutalia@gmail.com",
      ...stylex.props(styles.socialLink),
      children: /*#__PURE__*/_jsx(Gmail, {
        ...stylex.props(styles.social)
      })
    }), /*#__PURE__*/_jsx("a", {
      href: "https://www.facebook.com/people/Neural-Amp-Modeler-Online/61555763290703",
      target: "_blank",
      rel: "noopener noreferrer",
      ...stylex.props(styles.socialLink),
      children: /*#__PURE__*/_jsx(Facebook, {
        ...stylex.props(styles.social)
      })
    }), /*#__PURE__*/_jsx("a", {
      href: "https://www.youtube.com/user/kotekutalia",
      target: "_blank",
      rel: "noopener noreferrer",
      ...stylex.props(styles.socialLink),
      children: /*#__PURE__*/_jsx(YouTube, {
        ...stylex.props(styles.social)
      })
    }), /*#__PURE__*/_jsxs("p", {
      children: ["Original plugin by ", /*#__PURE__*/_jsx("a", {
        href: "https://www.neuralampmodeler.com",
        target: "_blank",
        rel: "noopener noreferrer",
        ...stylex.props(styles.link),
        children: "Steven Atkinson"
      })]
    }), /*#__PURE__*/_jsxs("small", {
      children: ["Default profile by\xA0", /*#__PURE__*/_jsx("a", {
        href: "https://tonehunt.org/ViciousAudio",
        target: "_blank",
        rel: "noopener noreferrer",
        ...stylex.props(styles.link),
        children: "Vicious Audio"
      })]
    })]
  });
};